const indexItems = [
  { label: '热门日漫', icon: 'ri-sun-line', color: 'accent', count: '1,200+' },
  { label: '超火韩漫', icon: 'ri-fire-line', color: 'primary', count: '890+' },
  { label: '国产漫画', icon: 'ri-flag-2-line', color: 'secondary', count: '650+' },
  { label: '热血战斗', icon: 'ri-sword-line', color: 'accent', count: '430+' },
  { label: '恋爱甜宠', icon: 'ri-heart-line', color: 'primary', count: '380+' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', color: 'secondary', count: '210+' },
  { label: '奇幻冒险', icon: 'ri-compass-3-line', color: 'accent', count: '290+' },
  { label: '搞笑日常', icon: 'ri-emotion-laugh-line', color: 'primary', count: '180+' },
  { label: '耽美百合', icon: 'ri-rainbow-line', color: 'secondary', count: '150+' },
];

const colorBgMap: Record<string, string> = {
  accent: 'bg-accent-100 group-hover:bg-accent-200',
  primary: 'bg-primary-100 group-hover:bg-primary-200',
  secondary: 'bg-secondary-100 group-hover:bg-secondary-200',
};

const colorIconMap: Record<string, string> = {
  accent: 'text-accent-500',
  primary: 'text-primary-500',
  secondary: 'text-secondary-500',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">主题索引</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">按题材快速浏览漫画资源，找到你最喜欢的漫画类型直接开始阅读</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.label}
              className={`group flex flex-col items-center text-center p-5 md:p-6 rounded-lg ${colorBgMap[item.color]} transition-colors cursor-pointer`}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-2xl md:text-3xl ${colorIconMap[item.color]}`}></i>
              </div>
              <div className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1">{item.label}</div>
              <div className="text-xs text-foreground-500">{item.count} 部作品</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}